import React from 'react';
import { RichText } from 'prismic-reactjs';
import { useStaticQuery } from 'gatsby';
import { StyledSmallText } from './small-text.styled';
var SmallText = function SmallText(_ref) {
    var richText = _ref.richText, color = _ref.color, customStyles = _ref.customStyles;
    var _useStaticQuery = useStaticQuery("3588428286"), prismicStylesConfig = _useStaticQuery.prismicStylesConfig;
    return /*#__PURE__*/ React.createElement(StyledSmallText, {
        color: color,
        customStyles: customStyles,
        configStyles: prismicStylesConfig.data.small_text_styles.text
    }, /*#__PURE__*/ React.createElement(RichText, {
        render: richText
    }));
};
export default SmallText;
